module.exports = __webpack_public_path__ + "img/ja.5b8a302a.png";